//# sourceMappingURL=mouse.mjs.map
/// <reference types="./mouse.d.mts" />
import * as $dynamic from "../../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $event from "../../../../redraw/redraw/event.mjs";
import * as $unsafe from "../../../../redraw/redraw/internal/unsafe.mjs";
import * as $ui from "../../../redraw/dom/event/ui.mjs";
import {
  altKey as alt_key,
  button,
  buttons,
  ctrlKey as ctrl_key,
  clientX as client_x,
  clientY as client_y,
  metaKey as meta_key,
  movementX as movement_x,
  movementY as movement_y,
  pageX as page_x,
  pageY as page_y,
  offsetX as offset_x,
  offsetY as offset_y,
  relatedTarget as related_target,
  screenX as screen_x,
  screenY as screen_y,
  shiftKey as shift_key,
  getModifierState as get_modifier_state,
} from "./events.ffi.mjs";

export {
  alt_key,
  button,
  buttons,
  client_x,
  client_y,
  ctrl_key,
  get_modifier_state,
  meta_key,
  movement_x,
  movement_y,
  offset_x,
  offset_y,
  page_x,
  page_y,
  related_target,
  screen_x,
  screen_y,
  shift_key,
};

/**
 * `MouseEvent` inherits `UIEvent`.
 */
export const as_ui_event = $unsafe.coerce;

/**
 * `MouseEvent` inherits `Event`.
 */
export const as_event = $unsafe.coerce;
